module.exports = __webpack_public_path__ + "static/media/clear-button.5842dc39.svg";